/**
 * Intake command-center detail route — eager gate twin (design-wired).
 *
 * The wired screen renders the design `AdminIntakeCommand`, which brings its OWN
 * console shell (rail + topbar). Mounting it inside the zinc `/clawinstall/admin`
 * layout's `<Outlet />` would double the chrome, so the route lives under
 * `admin_/intakes/` — TanStack's trailing-underscore escape keeps the
 * `/clawinstall/admin/intakes/$intakeId` URL while opting OUT of that layout —
 * and re-applies the SAME admin gate here in `beforeLoad`. That guard runs
 * server-side and bounces a non-admin before the page loads, so the old zinc
 * client-side redirect is dropped.
 *
 * The page component and its atom/RPC imports are deferred to `$intakeId.lazy.tsx`
 * so they never land in the always-loaded `main` chunk.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { requireAdmin } from "~/lib/server-admin.ts";

export const Route = createFileRoute("/clawinstall/admin_/intakes/$intakeId")({
  // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await
  beforeLoad: async () => {
    // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await
    const auth = await requireAdmin();
    return { auth };
  },
});
